import { fallback, maxValue, minValue, number, pipe } from 'valibot'

export const PERSPECTIVE_CAMERA_FAR_STEP : number = 50
export const PERSPECTIVE_CAMERA_FAR_MIN : number = 500
export const PERSPECTIVE_CAMERA_FAR_MAX : number = 4000
export const PERSPECTIVE_CAMERA_FAR_DEFAULT : number = 2000

export const CameraFarSchema = fallback(pipe(number(),
  minValue(PERSPECTIVE_CAMERA_FAR_MIN),
  maxValue(PERSPECTIVE_CAMERA_FAR_MAX),
  ), PERSPECTIVE_CAMERA_FAR_DEFAULT)
